export const REMIND_ADDRESSES = 'remindAddresses'
